module.exports = __webpack_public_path__ + "static/media/hello-memoji.fb517f3a.png";